<script lang="ts">
  import { storyblokEditable } from '@storyblok/svelte';
  import { EndorsementCard, type EndorsementCardProps } from '@stickerapp-org/athena/Card';
  import { contextKey, type CarouselContext } from '@stickerapp-org/athena/Carousel';
  import { getContext } from 'svelte';
  import type { EndorsementBlock } from '@storyblok-types';
  import { getUrlByLinkType } from '$lib/utilities/storyblok';

  const { blok }: { blok: EndorsementBlock } = $props();
  const carouselContext = getContext<CarouselContext>(contextKey);

  const endorsementCardProps: EndorsementCardProps = $derived({
    ...blok,
    variant: carouselContext ? 'horizontal' : 'vertical',
    logo: {
      url: blok.logo?.filename ?? '',
      alt: blok.logo?.alt ?? '',
    },
    quote: blok.quote ?? '',
    endorsedBy: {
      url: getUrlByLinkType(blok.endorsedByLink)?.href,
      name: blok.endorsedByName ?? '',
    },
  });
</script>

<EndorsementCard action={storyblokEditable} actionArg={blok} {...endorsementCardProps} />
